module.exports = __webpack_public_path__ + "img/no-data.be915728.jpg";